<vc-ref
  *ngIf="seller"
  [anchor]="false"
  resource="/members/profile-{{ seller.id }}.shtml"
  (click)="stopPropagation($event)"
  class="sellerBadge"
>
  <span
    *ngIf="hasImg"
    class="sellerBadge__img"
    [style.backgroundImage]="'url(' + imgixPath + seller.picture.path + '?auto=format&fm=pjpg&w=88&h=88&fit=crop)'"
  ></span>
  <span *ngIf="!hasImg" class="sellerBadge__img firstLetter">{{ firstLetter }}</span>
</vc-ref>
